/**
* Service for authentication-related API operations.
*
* Responsibilities:
* - User signup
* - User login
* - Temporary session retrieval
*/
import type { ApiClient } from "@/common/api/http/types";
import { ISessionInfo } from "@/common/api/services/types";

interface ISignupParams {
  username: string;
  email: string;
  captcha: string;
  session_id: string;
}

interface ISignupResponse {
  login_hint: string;
  connection_id: string;
}

interface ILoginParams {
  blocked?: boolean;
  login: string;
  captcha: string;
  session_id: string;
}

interface ILoginResponse {
  login_hint: string;
  connection_id: string;
}

export default class AuthService {
  public constructor(private readonly client: ApiClient) {}

  public async signup(params: ISignupParams): Promise<ISignupResponse> {
    return await this.client.post("/v2/auth/signup", params);
  }

  public async login(params: ILoginParams): Promise<ILoginResponse> {
    return await this.client.post("/v2/auth/login", params);
  }

  public getSession(sessionId?: string | null): Promise<ISessionInfo> {
    const query = new URLSearchParams();

    if (sessionId) {
      query.append("session_id", sessionId);
    }

    if (document.referrer) {
      query.append("referrer", document.referrer);
    }

    query.append("path", window.location.pathname);

    return this.client.get(`v2/auth/temporary${query.toString().length ? `?${query.toString()}` : ""}`);
  }
}
